import {useEffect, useState} from 'react'
import {
    EntityListWithPagination,
    EntityListWithPaginationFields,
    EntityPagination,
    EntityPaginationFields,
    PaginacionRequest
} from 'src/types'

// type FilterParam<TFilter> = TFilter extends undefined ? [] : [filter: TFilter]

// type UsePaginationProps<TEntity, TFilter> = {
//     loader: (
//         paginationParams: PaginacionRequest,
//         ...filterParams: FilterParam<TFilter>
//     ) => Promise<EntityListWithPagination<TEntity>>
// }

// const QUERY_STATUS = {
//     IDLE: 'idle',
//     LOADING: 'loading',
//     SUCCESS: 'success',
//     ERROR: 'error'
// } as const

type UsePaginationProps<TEntity, TFilter> = {
    loader: (paginationParams: PaginacionRequest, filter: TFilter) => Promise<EntityListWithPagination<TEntity>>
    initialFilter?: TFilter
}

type StateObject<TEntity> =
    | {
    status: 'idle',
    entities: TEntity[]
}
    | {
    status: 'loading',
    entities: TEntity[]
}
    | {
    status: 'success'
    entities: TEntity[]
    pagination: EntityPagination
}
    | {
    status: 'error',
    entities: TEntity[]
}

/**
 * Hook para manejar entidades con paginación. Recibe la función que carga los
 * datos y le inyecta los parámetros de paginación.
 * Devuelve la lista de entidades de la página actual, la información de
 * paginación y el handler "onChange", que debería recibir la página actual.
 */
export const usePagination = <TEntity, TFilter = undefined>(props: UsePaginationProps<TEntity, TFilter>) => {
    const {loader} = props
    const [state, setState] = useState<StateObject<TEntity>>({status: 'idle', entities: []})
    const [filter, setFilter] = useState<TFilter | undefined>(props.initialFilter && props.initialFilter)

    // const [filter, setFilter] = useState<TFilter | undefined>(props?.initialFilter)

    const [paramsPaginacion, setParamsPaginacion] = useState<PaginacionRequest>({
        [EntityPaginationFields.ActualPage]: 1,
        [EntityPaginationFields.PageSize]: 24
    })

    const onChange = (/*event: React.ChangeEvent,*/ page: number) => {
        setParamsPaginacion(params => ({
            ...params,
            [EntityPaginationFields.ActualPage]: page
        }))
    }

    const page = paramsPaginacion[EntityPaginationFields.ActualPage]

    const fetch = () => {
        setState({status: 'loading', entities: []})

        loader(paramsPaginacion, filter as TFilter)
            .then(vals => {
                setState({
                    status: 'success',
                    pagination: vals[EntityListWithPaginationFields.Pagination],
                    entities: vals[EntityListWithPaginationFields.List]
                })
            })
            .catch(() => {
                setState({status: 'error', entities: []})
            })
    }

    // const refetch = () => fetch()

    const setFilterAndSearch = (filter: TFilter) => {
        setFilter({...filter})
    }

    useEffect(() => {
        // filter && fetch()
        fetch()
    }, [page, filter])

    if (state.status === 'success') {
        return {
            entities: state.entities,
            paginacion: state.pagination,
            status: state.status,
            refetch: fetch,
            onChange,
            setFilterAndSearch
        }
    }

    return {entities: [], status: state.status, refetch: fetch, onChange, setFilterAndSearch}
}
